import { apiClient } from "@/api/api-client";
import createBaseService, { type Pagination } from "@/api/base-service.ts";
import type { CaseType } from "../../types/case-type";

const caseTypeService = {
	...createBaseService<CaseType>("/case-types"),
	listByBranch: async (params = {}) => {
		const response = await apiClient.get<{ data: CaseType[]; meta: Pagination }>("/case-types", { params });

		return response.data;
	},
};

export default caseTypeService;
